module.exports = __webpack_public_path__ + "img/lr3.cbb22f50.png";